import React from 'react'
import OverviewTable from './OverviewTable'

export default function EmployeeOverviewTable() {
  return <OverviewTable module="EMPLOYEE" />
}
